import { styled } from 'styled-components'
import { motion } from 'motion/react'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const StyledLogo = styled(motion.img)`
  height: 240px;
  pointer-events: none;

  @media (max-width: ${({ theme }) => theme.screens.small}) {
    height: 180px;
  }
`
